import React from "react";

interface FormSectionProps {
  children: React.ReactNode;
  formHeading: string;
  formDescription: string;
  formFooter?: React.ReactNode;
  className?: string;
}

export const FormSection: React.FC<FormSectionProps> = ({
  children,
  formHeading,
  formDescription,
  formFooter,
  className,
}) => {
  return (
    <div className={`space-y-10 divide-y divide-gray-900/10 ${className}`}>
      <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3 bg-gray-100 bg-opacity-85 dark:bg-gray-700 dark:bg-opacity-75 rounded p-3">
        <div className="px-4 sm:px-0">
          <h2 className="text-base font-semibold leading-7 text-gray-900 dark:text-gray-100">
            {formHeading}
          </h2>
          <p className="mt-1 text-sm leading-6 text-gray-600  dark:text-gray-300">
            {formDescription}
          </p>
        </div>

        <form
          className="shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2 bg-gray-100 bg-opacity-85 dark:bg-gray-700 dark:bg-opacity-75"
        >
          <div className="px-4 py-6 sm:p-8">
            <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
              <div className="sm:col-span-6">{children}</div>
            </div>
          </div>
          {formFooter && (
            <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
              {formFooter}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};
